﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailMandant extends GuiDetailGeneric {
    constructor() {
        super("Mandant");

        $("#btnMandantDataCopy").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnResetConsent").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnCreateMandantEanv").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnCheckEanv").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
    }
}
